var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table-filter',{attrs:{"filterComponents":[
      {
        type: 'WhereLikeFilter',
        label: 'Name',
        attributes: 'name'
      }
    ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.tableFilter),callback:function ($$v) {_vm.tableFilter=$$v},expression:"tableFilter"}}),_vm._v(" "),_c('v-table',{attrs:{"url":("/api/v1/circularMail/receiver/" + _vm.id),"filter":_vm.tableFilter,"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        type: 'LinkProfileCell',
        name: 'Kunde'
      },
      {
        attribute: 'received_messages.0.dialogMessageId',
        name: 'Dialog ID',
        type: 'DialogLink'
      },
      {
        attribute: 'received_messages.0.created_at',
        name: 'Empfangen am',
        type: 'DateTimeCell'
      }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }